import { ReactNode } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type CardHeaderProps = Readonly<{
  label?: string;
  supportingText?: string;
}>;

type SectionCardProps = CardHeaderProps &
  Readonly<{
    children: ReactNode;
  }>;

const CardHeader = ({ label, supportingText }: CardHeaderProps) =>
  label || supportingText ? (
    <Box sx={headerSx}>
      {label && (
        <Typography variant="text-md-semibold" sx={labelSx}>
          {label}
        </Typography>
      )}
      {supportingText && (
        <Typography variant="text-sm-regular" sx={supportingSx}>
          {supportingText}
        </Typography>
      )}
    </Box>
  ) : null;

/** White rounded card with an optional section label and supporting text. */
export const SectionCard = ({ label, supportingText, children }: SectionCardProps) => (
  <Box sx={cardSx}>
    <CardHeader label={label} supportingText={supportingText} />
    {children}
  </Box>
);

/** Labeled section without the card chrome. */
export const SectionGroup = ({ label, supportingText, children }: SectionCardProps) => (
  <Box sx={groupSx}>
    <CardHeader label={label} supportingText={supportingText} />
    {children}
  </Box>
);

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
  padding: backrs.spacing['spacing-3xl'],
  backgroundColor: backrs.colors['Colors/Base/White'],
  border: `1px solid ${backrs.colors['Gray/400']}`,
  borderRadius: backrs.radius['radius-xl'],
});

const groupSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
});

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
});

const labelSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const supportingSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
